import { useEffect, useRef } from 'react';

let nextOwnerId = 0;
const activeOwners: number[] = [];

const clipboardImage = (event: ClipboardEvent): File | null => {
  for (const item of Array.from(event.clipboardData?.items || [])) {
    if (item.type.startsWith('image/')) return item.getAsFile();
  }
  return null;
};

export const useImagePaste = (
  active: boolean,
  onImage: (file: File) => void,
): void => {
  const callback = useRef(onImage);
  callback.current = onImage;

  useEffect(() => {
    if (!active) return;
    const ownerId = ++nextOwnerId;
    activeOwners.push(ownerId);
    const handlePaste = (event: ClipboardEvent) => {
      if (activeOwners[activeOwners.length - 1] !== ownerId) return;
      const file = clipboardImage(event);
      if (file) callback.current(file);
    };
    window.addEventListener('paste', handlePaste as EventListener);
    return () => {
      window.removeEventListener('paste', handlePaste as EventListener);
      const index = activeOwners.indexOf(ownerId);
      if (index >= 0) activeOwners.splice(index, 1);
    };
  }, [active]);
};
